export const LoyaltySymbols = {
    LoyaltyProvider: Symbol.for("LoyaltyProvider"),
    LoyaltyNotificationService: Symbol.for("LoyaltyNotificationService"),
    LoyaltyNotificationProvider: Symbol.for("LoyaltyNotificationProvider")
}